<template>
  <div>
      <div class="craft">
          <div class="part-one">
              <div class="base-title">
                  <!-- <div class="part-one-content"></div> -->
              </div>
          </div>
        <div style="position: relative; top: -3rem">
          
        <div class="zccl part-one-content">
          <img class="top" src="./../assets/imgs/123/part-1-title.png" alt="" />
          <div class="content">
            <div class="des">
              (一)重点面向国内“双一流”高校高年级本科生或研究生，每年招募一批实习生；
            </div>
            <div class="des">
              (二) 按照“优中选优”的原则，重点面向国内“双一流”高校全日制本科及以上学历学位应届毕业生，每年选聘一批培训生；
            </div>
            <div class="des">
              (三) 市委组织部分配到我区的急需紧缺专业选调生全部作为培训生。
            </div>
          </div>
        </div>
          <div class="part-three" style="background: #fff">
              <img
                  src="../assets/imgs/123/part-2-title.png"
                  class="part-two-title-img"
              />
              <div class="main-content" style="padding: 0">
                  <div class="part-four-items">
                    综合管理类、经济金融类、规划建设类、产业发展类等。
                  </div>
              </div>
          </div>
        <div class="zccl">
          <img class="top" src="./../assets/imgs/123/part-3-title.png" alt="" />
          <div class="content">
            <div class="des">
              (一)中华人民共和国国籍，思想政治素质好，拥护中国共产党的路线方针政策；
            </div>
            <div class="des">
              (二)有志于从事党政工作或国企经营管理工作，适应力强、有创新意识，诚信务实、富有激情；
            </div>
            <div class="des">
              (三) 学业成绩良好，能如期毕业并取得相应学历学位证书；
            </div>
            <div class="des">
              (四) 具有正常履行职责的身体条件和心理素质；
            </div>
            <div class="des">
              (五) 符合法律法规和岗位要求的其他资格条件。
            </div>
          </div>
        </div>
          <div class="part-three-extra">
              <img
                  src="../assets/imgs/123/part-4-title.png"
                  class="part-two-title-img"
              />
              <div class="main-content" style="margin-top: 0.4rem">
                  <div class="part-four-title">一. 岗位类型</div>
                  <div class="part-four-items">
                      1. 知名重点企业。行政文秘类、人力资源类、财务审计类、法务类、市场营销类、产品研发类、生产运营类、工程类、采购类等。<br>
                      2. 党政机关（事业单位）、产业功能区、国有平台公司。行政文秘类、公共管理类、经济金融类、财务类、社会工作类、规划建设类、智能制造类、现代农业类、文化产业类、电子商务类、企业管理类、市场营销类、产品研发类、生产运营类、工程项目类、投资发展类、法律法务类等。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">二. 专业背景</div>
                  <div class="part-four-items">
                    具备企事业单位实习岗位所需的专业知识背景。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">三. 资格条件</div>
                  <div class="part-four-items">
                    符合企事业单位实习岗位所要求的基本资格条件。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">四. 能力要求</div>
                  <div class="part-four-items">
                    1. 具备较强的学习能力、沟通能力、适应能力和责任意识；<br>
                    2. 具有较好的专业基础知识和团队协作意识；<br>
                    3. 熟悉现代办公软件操作。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">五. 优先条件</div>
                  <div class="part-four-items">
                    1. 学业成绩名列前茅（专业排名前10%）或校级及以上奖学金获得者优先；<br>
                    2. 校、院系学生会（团委、研究生会）、协会（社团）等学生干部或班级学生干部优先；<br>
                    3. 校级及以上“优秀共产党员”“三好学生”“优秀学生干部”“优秀团干部”获得者优先；<br>
                    4. 具有良好的英语听说读写能力优先（大学英语六级考试425分以上、TOEIC听读公开考试715分以上、TOEFL iBT85分以上、IELTS6.5分以上)。
                  </div>
              </div>
          </div>
          <div class="part-three-extra">
              <img
                  src="../assets/imgs/123/part-5-title.png"
                  class="part-two-title-img"
              />
              <div class="circle-title">
                <div class="circle"></div>
                党政机关（事业单位）
              </div>
              <div class="main-content" style="margin-top: 0.4rem">
                  <div class="part-four-title">一. 岗位类型</div>
                  <div class="part-four-items">
                    行政文秘类、公共管理类、经济金融类、财务类、社会工作类等
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">二. 专业背景</div>
                  <div class="part-four-items">
                    （1）行政文秘类：中国语言文学等专业；<br>
                    （2）公共管理类：公共管理、管理科学与工程、农业（农林）经济管理等专业；<br>
                    （3）经济金融类：金融（学）、财政学、税务、保险、经济学、应用经济学、理论经济学、经济与贸易、统计学、应用统计等专业；<br>
                    （4）财务类：会计（学）、审计、资产评估等专业；<br>
                    （5）社会工作类：法学、法律、社会学、社会工作等专业。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">三. 资格条件</div>
                  <div class="part-four-items">
                    满足下列条件之一：<br>
                    （1）中国共产党党员（含预备党员）；<br>
                    （2）学业成绩名列前茅（专业排名前10%）或国家奖学金获得者；<br>
                    （3）本科或研究生期间担任校、院系学生会（团委、研究生会）或协会（社团）主要干部（主席、副主席等）；<br>
                    （4）本科或研究生期间获校级及以上“优秀毕业生”“优秀共产党员”“三好学生”“优秀学生干部”“优秀团干部”；<br>
                    （5）具有丰富的社会实践经验。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">四. 能力要求</div>
                  <div class="part-four-items">
                    （1）具备较强的文字写作能力、语言表达能力和团队协作意识；<br>
                    （2）具备较强的分析能力、逻辑思维能力、沟通协调能力和执行能力；<br>
                    （3）能够熟练操作现代办公软件。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">五. 优先条件</div>
                  <div class="part-four-items">
                    （1）具有党政机关（事业单位）6个月及以上实习（挂职）经历优先；<br>
                    （2）具有初级及以上专业技术职称优先。
                  </div>
              </div>
              <div class="circle-title">
                <div class="circle"></div>
                产业功能区
              </div>
              <div class="main-content">
                  <div class="part-four-title">一. 岗位类型</div>
                  <div class="part-four-items">
                    规划建设类、智能制造类、现代农业类、文化产业类、电子商务类等。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">二. 专业背景</div>
                  <div class="part-four-items">
                    1）规划建设类：建筑学、城乡规划学、城市规划（与设计）、风景园林（学）、资源环境与城乡规划管理、人文地理（与城乡规划）等专业；<br>
                    2）智能制造类：机械、机械工程、工业设计（工程）、仪器、仪器科学与技术、自动化、控制科学与控制工程、交通运输工程、生物（医学）工程、材料科学与工程、食品科学与工程、物流管理与工程等专业；<br>
                    3）现代农业类：林学、水产、草学、作物学、园艺学、农业资源与环境、植物保护、农业推广、农业（林业）工程、农（水）产品加工及贮藏工程等专业；<br>
                    4）文化产业类：文物与博物馆、文化产业管理、旅游管理等专业；<br>
                    5）电子商务类：电子商务等专业。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">三. 资格条件</div>
                  <div class="part-four-items">
                    满足下列条件之一：<br>
                    1）中国共产党党员（含预备党员）；<br>
                    2）学业成绩优良（专业排名前50%）或校级及以上奖学金获得者；<br>
                    3）本科或研究生期间具有校、院系学生会（团委、研究生会）或协会（社团）等学生工作经历；<br>
                    4）本科或研究生期间获院系及以上“优秀共产党员”“三好学生”“优秀学生干部”“优秀团干部”；<br>
                    5）具有丰富的社会实践经验。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">四. 能力要求</div>
                  <div class="part-four-items">
                    （1）具备较强的文字写作能力、语言表达能力和团队协作意识；<br>
                    （2）具备较强的研究分析能力、沟通协调能力、执行能力和服务意识；<br>
                    （3）具有与专业岗位相匹配的较强的软件操作能力。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">五. 优先条件</div>
                  <div class="part-four-items">
                    （1）具有政府规划建设部门、产业园区6个月及以上实习（挂职）经历优先；<br>
                    （2）具有甲级规划院（建筑院）、知名咨询机构6个月及以上实习（见习）经历优先。
                  </div>
              </div>
              <div class="circle-title">
                <div class="circle"></div>
                国有平台公司
              </div>
              <div class="main-content">
                  <div class="part-four-title">一. 岗位类型</div>
                  <div class="part-four-items">
                    企业管理类、市场营销类、产品研发类、生产运营类、工程项目类、投资发展类、法律法务类。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">二. 专业背景</div>
                  <div class="part-four-items">
                    （1）企业管理类：工商管理、房地产开发与管理等专业；<br>
                    （2）市场营销类：市场营销、广告学等专业；<br>
                    （3）产品研发类：工业设计、产品设计、计算机科学与技术等专业；<br>
                    （4）生产运营类：管理科学（与工程）、网络与新媒体、电子商务等专业；<br>
                    （5）工程项目类：工程管理、土木工程、结构工程、市政工程、工程造价等专业；<br>
                    （6）投资发展类：投资学、信用管理等专业；<br>
                    （7）法律法务类：法学、法律等专业。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">三. 资格条件</div>
                  <div class="part-four-items">
                    满足下列条件之一：<br>
                    1）中国共产党党员（含预备党员）；<br>
                    2）学业成绩良好；<br>
                    3）本科或研究生期间担任过班级学生干部；<br>
                    4）本科或研究生期间参加过院系及以上社会实践活动。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">四. 能力要求</div>
                  <div class="part-four-items">
                    （1）具备较强的分析能力、沟通能力和团队协作意识；<br>
                    （2）具备较强的综合协调能力、策划推广能力和自我驱动与抗压能力；<br>
                    （3）具备一定的经济金融、现代管理等方面知识，能够熟练操作现代办公软件。
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">五. 优先条件</div>
                  <div class="part-four-items">
                    （1）具有政府国资管理行业主管部门6个月及以上实习（挂职）经历优先；<br>
                    （2）具有中央企业、国有企业、外资企业、知名民营企业、金融机构6个月及以上实习（见习）经历优先。
                  </div>
              </div>
          </div>
          <div class="part-three-extra">
              <img
                  src="../assets/imgs/123/part-6-title.png"
                  class="part-two-title-img"
              />
              <div class="circle-title" style="margin-bottom: 0rem">
                <div class="circle"></div>
                （一）实习生培养体系
              </div>
              <div class="main-content" style="margin-top: 0.2rem">
                  <div class="part-four-items">
                    围绕实习生职业生涯探寻，通过实施“‘津’遇未来”项目，开展为期8周左右的实习培养，同时选拔培养校园雇主品牌传播大使。
                  </div>
              </div>
              <div class="circle-title" style="margin-bottom: 0rem">
                <div class="circle"></div>
                （二）培训生培养体系
              </div>
              <div class="main-content" style="margin-top: 0.2rem">
                  <div class="part-four-items">
                    围绕培训生职业发展规划，通过实施“‘津’彩启航”“‘津’益求精”“‘津’城圆梦”三大项目，整合优势资源，构建品牌化培养体系，开展为期3年左右的“全流程、全方位、进阶式”培养。
                  </div>
              </div>
          </div>
          <div class="part-three-extra">
              <img
                  src="../assets/imgs/123/part-7-title.png"
                  class="part-two-title-img"
              />
              <div class="circle-title" style="margin-bottom: 0rem">
                <div class="circle"></div>
                （一）时间安排
              </div>
              <div class="main-content" style="margin-top: 0.2rem">
                  <div class="part-four-items">
                    每年3月—5月开展春季招聘、9月—11月开展秋季招聘。
                  </div>
              </div>
              <div class="circle-title" style="margin-bottom: 0rem">
                <div class="circle"></div>
                （二）信息发布
              </div>
              <div class="main-content" style="margin-top: 0.2rem">
                  <div class="part-four-items">
                    采取“线上+线下”方式，发布“津津希望”选培计划相关信息。线上主要通过网络途径发布，线下由区领导率队赴目标高校进行现场宣讲、现场推介。
                  </div>
              </div>
              <div class="circle-title" style="margin-bottom: 0rem">
                <div class="circle"></div>
                （三）招聘流程
              </div>
              <div class="main-content">
                  <div class="part-four-title">一. 实习生招募流程</div>
                  <div class="part-four-items">
                    <p><img src="../assets/imgs/123/num1.png" alt=""><span>简历投递</span></p>
                    <p><img src="../assets/imgs/123/num2.png" alt=""><span>简历评估</span></p>
                    <p><img src="../assets/imgs/123/num3.png" alt=""><span>电话面试（初面）</span></p>
                    <p><img src="../assets/imgs/123/num4.png" alt=""><span>现场面试（终面）</span></p>
                    <p><img src="../assets/imgs/123/num5.png" alt=""><span>签订实习协议</span></p>
                    <p><img src="../assets/imgs/123/num6.png" alt=""><span>实习</span></p>
                  </div>
              </div>
              <div class="main-content">
                  <div class="part-four-title">二. 培训生选聘流程</div>
                  <div class="part-four-items">
                    <p><img src="../assets/imgs/123/num1.png" alt=""><span>简历投递</span></p>
                    <p><img src="../assets/imgs/123/num2.png" alt=""><span>简历评估</span></p>
                    <p><img src="../assets/imgs/123/num3.png" alt=""><span>电话面试（初面）</span></p>
                    <p><img src="../assets/imgs/123/num4.png" alt=""><span>综合素质测评</span></p>
                    <p><img src="../assets/imgs/123/num5.png" alt=""><span>现场面试（终面）</span></p>
                    <p><img src="../assets/imgs/123/num6.png" alt=""><span>签订三方协议</span></p>
                    <p><img src="../assets/imgs/123/num7.png" alt=""><span>入职体检</span></p>
                    <p><img src="../assets/imgs/123/num8.png" alt=""><span>毕业后签订聘用合同</span></p>
                  </div>
              </div>
          </div>
            <div class="part-three" style="background: #fff">
                <img
                    src="../assets/imgs/123/part-8-title.png"
                    class="part-two-title-img"
                />
                <div class="main-content" style="padding: 0">
                    <div class="part-four-items">
                      实习生在我区实习期间，按照1800元/人·月的标准给予实习补助，并为其提供基本的生活保障，购买人身意外伤害保险，报销一次学校至新津的往返高铁二等座车票。
                    </div>
                </div>
            </div>
          <div class="contact">
              <img
                  class="top"
                  src="./../assets/imgs/123/part-9-title.png"
                  alt=""
              />
              <div class="content">
                  <div class="number">
                      <span class="label">政策咨询电话：</span>
                      <div>
                          <a href="tel:028-61888121">028-82593582</a>
                      </div>
                  </div>
                  <div class="unit">
                      <span class="label">责任单位：</span>
                      成都市新津区委组织部
                  </div>
              </div>
          </div>

          <!-- <div class="bottom-info" style="margin-top: 0.25rem">
              责任单位：成都市人力资源和社会保障局专业技术人员服务管理处
          </div>
          <div class="bottom-info" style="margin-top:0.15rem">
              咨询电话： <a href="tel:028-61888245">028-61888245</a>、<a href="tel:028-61888121">028-61888121</a>
          </div> -->
          <!-- <bottom
                  phone="028-61888245"
                  phone2="028-61888121"
                  unit="成都市人力资源和社会保障局专业技术人员服务管理处"
              ></bottom> -->
        </div>
      </div>
  </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
// import call from "../components/call.vue";

export default {
  name: "",
  data() {
      return {

      };
  },
  components: {
      // bottom,
      // call,
  },
  created() {},
  mounted() {},
  computed: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.craft {
  background: #0839b7;
  overflow: hidden;
  padding: 0.24rem 0.12rem;
  padding-bottom: 1.65rem;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  overflow-y: auto;

  .part-title {
      font-size: 0.34rem;
      //font-family:: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #333333;
      position: relative;

      &::before {
          position: absolute;
          content: "";
          width: 0.28rem;
          height: 0.28rem;
          border-radius: 50%;
          background: none;
          border: 0.06rem solid #ff6d60;
          box-sizing: border-box;
          top: 0.08rem;
          left: -0.2rem;
      }
  }

  .part-text {
      font-size: 0.26rem;
      //font-family:: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #4e4e4e;
      line-height: 0.44rem;
      text-align: left;
  }

  .part-one {
      width: 7.5rem;
      min-height: 7.2rem;
      box-sizing: border-box;
      padding-bottom: 0.3rem;
      margin: 0 auto;

      .base-title {
          width: 7.26rem;
          min-height: 5.58rem;
          background: url(../assets/imgs/123/base-title.png);
          background-size: 100% 100%;
          position: relative;

          .part-one-content {
              width: 6.85rem;
              padding-bottom: 0.2rem;
              background: #ffffff;
              border-radius: 10px;
              position: absolute;
              top: 4.02rem;
              left: 0.22rem;
              padding-left: 0.36rem;
              padding-right: 0.37rem;
              box-sizing: border-box;
              padding-bottom: 0.35rem;

              .part-one-title-img {
                  position: absolute;
                  top: -0.32rem;
                  left: -0.18rem;
                  width: 7.03rem;
                  height: 1.37rem;
              }

              .part-one-title {
                  margin-top: 0.98rem;
                  text-align: left;
                  margin-left: 0.34rem;
              }

              .part-one-text {
                  margin-top: 0.16rem;
              }
          }
      }
  }

  .part-two-title-img {
      width: 7.03rem;
      height: 1.37rem;
      top: 0;
      left: -0.2rem;
      position: absolute;
  }

  .part-two {
      margin-left: 0.02rem;
      width: 6.85rem;
      margin-top: 0.22rem;
      background: #e8eeff;
      border-radius: 10px;
      box-sizing: border-box;
      display: inline-block;
      position: relative;

      .part-two-content {
          margin-top: 1.2rem;
          width: 100%;
          padding: 0.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          font-size: 0.26rem;
          //font-family:: PingFang SC-Medium, PingFang SC;
          font-weight: 500;
          color: #4e4e4e;
          line-height: 0.44rem;
          text-align: left;
      }
  }

  .part-three {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 0.28rem;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.22rem;
      border: 0.00001px solid transparent;
      position: relative;
      padding: 1.44rem 0.25rem 0 0.25rem;
      padding-bottom: 0.35rem;

      .part-four-title {
          text-align: left;
          margin-left: 0.35rem;

          &::before {
              position: absolute;
              content: "";
              width: 0.28rem;
              height: 0.28rem;
              border-radius: 50%;
              background: none;
              border: 0.06rem solid #ff6d60;
              box-sizing: border-box;
              top: 0.08rem;
              left: -0.38rem;
          }
      }

      .main-content {
          margin-top: 0.1rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.5rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;
          padding-bottom: 0.2rem;

          .part-four-items {
              box-sizing: border-box;
              position: relative;
              margin-bottom: 0.15rem;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
          }
      }
  }

  .part-three-extra {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 0.15rem;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      margin: 0 auto;
      margin-top: 0.22rem;
      border: 0.00001px solid transparent;
      position: relative;
      padding: 1.44rem 0.25rem 0 0.25rem;
      padding-bottom: 0.35rem;
      .circle-title {
        font-weight: bold;
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            color: #333;
            margin-bottom: 0.5rem;
            margin-top: 0.2rem;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
              margin-right: 0.05rem;
            }
      }

      .main-content {
          margin-top: 0.8rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.5rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;
          padding-bottom: 0.2rem;
          position: relative;
          // margin-bottom: 0.8rem;

          .part-four-title {
              text-align: left;
              position: absolute;
              top: 0;
              left: 50%;
              width:2.98rem;
              font-size: 0.32rem;
              background-color: #739bfeff;
              color: #fff;
              border-radius: 20px;
              text-align:center;
              padding: 0.18rem 0.2rem;
              transform: translate(-50%, -50%);
              white-space: nowrap;
          }

          .part-four-items {
              box-sizing: border-box;
              position: relative;
              margin-bottom: 0.15rem;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
              & > p {
                display: flex;
                align-items: center;
                font-size: 0.26rem;
                color: #4E4E4E;
                font-weight: bold;
                margin-top: 0.3rem;
                img {
                  width: 0.39rem;
                  height: 0.39rem;
                  margin-right: 0.14rem;
                }
              }
          }
      }
  }

  .part-four {
      width: 6.85rem;
      background: #e8eeff;
      border-radius: 10px;
      margin-left: 0.02rem;
      margin-top: 0.22rem;
      box-sizing: border-box;
      display: inline-block;
      position: relative;
      padding: 1.2rem 0.25rem 0 0.25rem;

      .part-four-title {
          text-align: left;
          margin-left: 0.35rem;

          &::before {
              position: absolute;
              content: "";
              width: 0.28rem;
              height: 0.28rem;
              border-radius: 50%;
              background: none;
              border: 0.06rem solid #ff6d60;
              box-sizing: border-box;
              top: 0.08rem;
              left: -0.38rem;
          }
      }

      .main-content {
          margin-top: 0.34rem;
          width: 6.35rem;
          background: #ffffff;
          border-radius: 10px;
          box-sizing: border-box;
          padding-top: 0.8rem;
          padding-left: 0.35rem;
          padding-right: 0.31rem;

          .part-four-items {
              box-sizing: border-box;
              border-left: 0.02rem dashed #739bfe;
              margin-bottom: 0.6rem;
              padding-left: 0.33rem;
              padding-top: 0.2rem;
              position: relative;
              font-size: 0.26rem;
              //font-family:: PingFang SC-Medium, PingFang SC;
              font-weight: 500;
              color: #4e4e4e;
              line-height: 0.44rem;
              text-align: left;
              padding-bottom: 0.25rem;

              .title-bg {
                  position: absolute;
                  width: 3.31rem;
                  height: 0.6rem;
                  top: -0.6rem;
                  left: -0.25rem;
                  display: inline-flex;
                  align-items: center;
                  font-size: 0.34rem;
                  //font-family:: PingFang SC-Bold, PingFang SC;
                  font-weight: bold;
                  color: #3d5aa3;
                  padding-left: 0.58rem;
                  background: url(../assets/imgs/craft/part4-1.png);
                  background-size: 100% 100%;
                  white-space: nowrap;
              }

              .title-bg2 {
                  background: url(../assets/imgs/craft/part4-2.png);
                  background-size: 100% 100%;
              }

              .title-bg3 {
                  background: url(../assets/imgs/craft/part4-3.png);
                  background-size: 100% 100%;
              }

              .title-bg4 {
                  background: url(../assets/imgs/craft/part4-4.png);
                  background-size: 100% 100%;
              }

              .title-bg5 {
                  background: url(../assets/imgs/craft/part4-5.png);
                  background-size: 100% 100%;
              }

              .title-bg6 {
                  background: url(../assets/imgs/craft/part4-6.png);
                  background-size: 100% 100%;
              }

              .inside-title {
                  font-weight: 800;
              }

              .part-four-content1 {
                  margin-bottom: 0.2rem;

                  p {
                      margin: 0.01rem;
                  }
              }
          }
      }
  }

  .zccl {
      position: relative;
      margin-top: 0.22rem;
      font-size: 0.26rem;

      .top {
        width: 7.03rem;
        height: 1.37rem;
        margin-left: -0.18rem;
      }

      .content {
        width: 6.85rem;
        background: #D4E0FF;
        margin: -0.45rem auto 0;
        padding: 0.33rem;
        box-sizing: border-box;
        border-radius: 0rem 0rem 0.26rem 0.26rem;
        padding-top: 0.28rem;

        font-weight: 500;
        text-align: left;
        color: #4e4e4e;

        .des {
          color: #4e4e4e;
          text-align: left;
          background: #ffffff;
          border-radius: 0.2rem 0.2rem 0.2rem 0.2rem;
          padding: 0.35rem 0.23rem 0.3rem;
          margin-top: 0.2rem;
          position: relative;
          text-align: left;
          line-height: 0.44rem;

          color: #4E4E4E;
          font-size: 0.26rem;
          font-weight: normal;

          .title {
            font-weight: bold;
            position: absolute;
            top: -0.6rem;
            left: 50%;
            transform: translateX(-50%);
            width: 100%;
            // height: 0.67rem;
            font-size: 0.3rem;

            // border: 1px solid red;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            .circle {
              width: 0.22rem;
              height: 0.22rem;
              border: 0.06rem solid #FF6D60;
              border-radius: 50%;
            }
          }

        }
      }
    }

}
</style>
